<template>
    <b-modal
        id="create_edit_modal_form"
        ref="create_edit_modal_form"
        :title="title"
        :ok-title="btn_text"
        close-title="Fechar"
        cancel-title="Cancelar"
        :ok-disabled="form.errors.any()"
        no-close-on-backdrop
        v-model="showModal"
        @ok="handleOk"
    >
        <form
            @submit.stop.prevent="handleOk"
            @keydown="form.errors.clear($event.target.name)"
        >
            <label>Código</label>
            <b-form-input
                type="text"
                placeholder="Código"
                v-model="form.cd"
                name="cd"
            >
            </b-form-input>
            <b-form-feedback
                v-text="form.errors.get('cd')"
                v-if="form.errors.has('cd')"
            ></b-form-feedback>

            <b-form-feedback
                v-text="form.errors.get('qrcode')"
                v-if="form.errors.has('qrcode')"
            ></b-form-feedback>

            <label>Capacidade Kg</label>
            <b-form-input
                type="number"
                placeholder="Capacidade Kg"
                v-model="form.capacidade_kg"
                name="capacidade_kg"
            >
            </b-form-input>
            <b-form-feedback
                v-text="form.errors.get('capacidade_kg')"
                v-if="form.errors.has('capacidade_kg')"
            ></b-form-feedback>

            <label>Capacidade m³</label>
            <b-form-input
                type="number"
                placeholder="Capacidade m³"
                v-model="form.capacidade_cubado"
                name="capacidade_cubado"
            >
            </b-form-input>
            <b-form-feedback
                v-text="form.errors.get('capacidade_cubado')"
                v-if="form.errors.has('capacidade_cubado')"
            ></b-form-feedback>

            <label>Largura em cm</label>
            <b-form-input
                type="number"
                placeholder="Largura em cm"
                v-model="form.dimensao_largura"
                name="dimensao_largura"
            >
            </b-form-input>
            <b-form-feedback
                v-text="form.errors.get('dimensao_largura')"
                v-if="form.errors.has('dimensao_largura')"
            ></b-form-feedback>

            <label>Comprimento em cm</label>
            <b-form-input
                type="number"
                placeholder="Comprimento em cm"
                v-model="form.dimensao_comprimento"
                name="dimensao_comprimento"
            >
            </b-form-input>
            <b-form-feedback
                v-text="form.errors.get('dimensao_comprimento')"
                v-if="form.errors.has('dimensao_comprimento')"
            ></b-form-feedback>

            <label>Status</label>
            <b-form-group>
                <b-form-radio-group
                    v-model="form.status"
                    :options="optionsLivStatus"
                    name="status"
                    stacked
                    plain
                ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
                v-text="form.errors.get('status')"
                v-if="form.errors.has('status')"
            ></b-form-feedback>
        </form>
        <div slot="modal-footer" class="w-100">
            <div class="float-left">
                <spinner v-if="loading" message="Processando..."></spinner>
            </div>
            <div class="float-right">
                <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
                <b-btn @click="showModal = false" variant="secondary">
                    Fechar
                </b-btn>
                <b-btn
                    @click="handleOk($event)"
                    variant="secondary"
                    :disabled="isDisabled"
                >
                    Enviar
                </b-btn>
            </div>
        </div>
    </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";

export default {
    components: {
        AvisoErros,
    },
    props: {
        refreshTable: { type: Function },
    },
    data() {
        return {
            title: "",
            btn_text: "",
            action: "",
            loading: false,
            isDisabled: false,
            loadingData: true,
            showModal: false,
            optionsLivStatus: [],
            errors_array: [],
            form: new Form({
                pallet_id: "",
                cd: "",
                qrcode: "",
                capacidade_kg: "",
                capacidade_cubado: "",
                dimensao_largura: null,
                dimensao_comprimento: null,
                status: null,
            }),
            helpForm: new Form({ params: [] }),
            fields: [
                {
                    name: "__checkbox",
                    titleClass: "center aligned",
                    dataClass: "center aligned",
                },
                {
                    name: "cd",
                    title: "Código",
                    sortField: "cd",
                },
                {
                    name: "descr",
                    title: "Descrição",
                    sortField: "descr",
                },
                {
                    name: "__slot:status",
                    title: "Status",
                    sortField: "status",
                },
                {
                    name: "__slot:actions", // <----
                    title: "Ações",
                    titleClass: "center aligned",
                    dataClass: "center aligned",
                },
            ],
            css: {
                loadingClass: "loading",
                ascendingIcon: "glyphicon glyphicon-chevron-up",
                descendingIcon: "glyphicon glyphicon-chevron-down",
                handleIcon: "glyphicon glyphicon-menu-hamburger",
            },
            moreParams: {},
        };
    },
    mounted() {
        this.getLivStatus();
    },
    methods: {
        handleOk(e) {
            e.preventDefault();
            if (this.action == "insert") {
                this.onStore();
            } else {
                this.onUpdate(this.form.pallet_id);
            }
        },
        onCreate() {
            this.isDisabled = false;
            this.loading = false;
            this.title = "Cadastrar";
            this.btn_text = "Cadastrar";
            this.action = "insert";
            this.errors_array = [];
            this.form.reset();
            this.form.status = 1;
            this.$refs.create_edit_modal_form.show();
        },
        onEdit(data) {
            this.isDisabled = false;
            this.loading = false;
            this.title = "Alterar";
            this.btn_text = "Alterar";
            this.action = "update";
            this.form.reset();
            this.errors_array = [];
            this.form.pallet_id = data.pallet_id;
            this.form.cd = data.cd;
            this.form.capacidade_kg = data.capacidade_kg;
            this.form.capacidade_cubado = data.capacidade_cubado;
            this.form.dimensao_largura = data.dimensao_largura;
            this.form.dimensao_comprimento = data.dimensao_comprimento;
            this.form.status = data.status.valor;
            this.$refs.create_edit_modal_form.show();
        },
        onStore() {
            this.loading = true;
            this.isDisabled = true;
            this.form
                .post("/api/pallet/store")
                .then((response) => {
                    new ReturnApi(response, this);
                    if (this.metodo != null) {
                        this.metodo();
                    }
                })
                .catch((errors) => {
                    new ReturnApi(errors, this, true, null, null, false);
                    this.errors_array = "";
                    this.errors_array = [];
                    for (var property in errors) {
                        if (errors.hasOwnProperty(property)) {
                            if (typeof errors[property] === "object") {
                                errors[property].forEach((obj) => {
                                    this.errors_array.push({
                                        erro: obj,
                                    });
                                });
                            }
                        }
                    }
                });
        },
        onUpdate(id) {
            this.loading = true;
            this.isDisabled = true;
            this.form
                .patch("/api/pallet/update/" + id)
                .then((response) => {
                    new ReturnApi(response, this);
                    if (this.refreshTable != null) {
                        this.refreshTable();
                    }
                })
                .catch((errors) => {
                    new ReturnApi(errors, this, true, null, null, false);
                    this.errors_array = [];
                    console.log("deu erro", errors);
                    for (var property in errors) {
                        if (errors.hasOwnProperty(property)) {
                            if (typeof errors[property] === "object") {
                                errors[property].forEach((obj) => {
                                    this.errors_array.push({
                                        erro: obj,
                                    });
                                });
                            }
                        }
                    }
                });
        },
        getLivStatus() {
            this.helpForm.params = { tabela: "pallet", coluna: "status" };

            this.helpForm
                .get("/api/listitemvalor/jsonlist")
                .then((response) => {
                    new ReturnApi(response, this, true, false, false);
                    response.items.forEach((obj) => {
                        this.optionsLivStatus.push({
                            text: obj.descr,
                            value: obj.valor,
                        });
                    });
                })
                .catch((errors) => {
                    new ReturnApi(errors, this);
                });
        },
    },
    computed: {
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            },
        },
    },
};
</script>
